/**
 * Server creation, the rail, leave and delete (Console v2 §3.1, slice S1).
 * i18n/index.ts spreads this table; the slice adds its own keys here.
 */
import type { Dict } from '../core';

export const serversV2En: Dict = {
  // the (+) dialog, in Discord's words
  'sv.add.title': 'Create Your Server',
  'sv.add.body':
    'Your server is where you and your friends hang out. Make yours and start talking.',
  'sv.add.own': 'Create My Own',
  'sv.add.ownHint': 'A server for you and your friends',
  'sv.add.limited': 'Creating servers is limited right now. You can still join with an invite.',
  'sv.add.haveInvite': 'Have an invite already?',
  'sv.add.join': 'Join a Server',
  'sv.add.back': 'Back',
  // Customize your server
  'sv.make.title': 'Customize Your Server',
  'sv.make.body':
    'Give your new server a personality with a name and an icon. You can always change it later.',
  'sv.make.name': 'Server name',
  'sv.make.defaultName': "{name}'s server",
  'sv.make.nameLength': 'A server name is 2 to 100 characters.',
  'sv.make.upload': 'Upload',
  'sv.make.icon': 'Server icon',
  'sv.make.removeIcon': 'Remove icon',
  'sv.make.create': 'Create',
  'sv.make.slow': 'Your server is ready. It will show up in a moment.',
  // Join a Server
  'sv.join.title': 'Join a Server',
  'sv.join.body': 'Enter an invite below to join an existing server.',
  'sv.join.label': 'Invite link',
  'sv.join.examples': 'Invites look like {code} or {link}',
  'sv.join.go': 'Join Server',
  'sv.join.bad': 'Enter a valid invite link or invite code.',
  // the rail
  'sv.rail.up': 'Move up',
  'sv.rail.down': 'Move down',
  'sv.rail.moved': 'Moved {name} to position {n}',
  'sv.rail.saveFailed': 'Couldn’t save the server order. Try again.',
  // leave and delete (the server menu)
  'sv.leave': 'Leave Server',
  'sv.leave.title': 'Leave {name}',
  'sv.leave.body':
    'Are you sure you want to leave {name}? You won’t be able to rejoin this server unless you are re-invited.',
  'sv.leave.done': 'You left {name}',
  'sv.delete': 'Delete Server',
  'sv.delete.title': 'Delete {name}',
  'sv.delete.body': 'Are you sure you want to delete {name}? This action cannot be undone.',
  'sv.delete.type': 'Enter server name',
  'sv.delete.mismatch': 'You didn’t enter the server name correctly.',
  'sv.delete.done': '{name} was deleted',
  // the server's refusals (mod/actions.ts errorText reads ns.err.<code>)
  'ns.err.30001':
    'You have reached the most servers you can be in. Leave one to join or create another.',
  'ns.err.100049': 'Creating servers is limited right now. You can still join with an invite.',
  // the server's audit log: console actions (Console v2 decision 2)
  'sv.audit.staff': 'Neosocial staff',
  'sv.audit.via': 'by Neosocial staff',
};
